export enum EQuestionDifficulty {
  EASY = 'EASY',
  MEDIUM = 'MEDIUM',
  HARD = 'HARD'
}

export enum EQuestionType {
  MANUAL = 'MANUAL',
  AI = 'AI'
}

export enum EQuestionStatus {
  ACTIVE = 'ACTIVE',
  HIDDEN = 'HIDDEN',
  REPORTED = 'REPORTED'
}
